import script from "./CreateWorkstationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWorkstationModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateWorkstationModal.vue?vue&type=style&index=0&id=afe6d426&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe6d426"]])

export default __exports__